import { HotmartConfirmModal } from '../hotmart/HotmartConfirmModal'

export class HotmartCoConfirmModal extends HotmartConfirmModal {
  override afterHotmartModalRender(): void {
    const style = document.createElement('style')
    style.innerHTML = `
      :host {
        --primary: var(--hc-color-primary-700);
        --primary-dark: var(--hc-color-primary-400);
        --primary-darker: var(--hc-color-primary-600);
        --font-family: Poppins;
        --blue: var(--hc-color-primary-700);
        --blue-lighter: var(--hc-color-neutral-300);
      }
    `
    this.root.appendChild(style)
  }
}
